import axiosInstance from "./axiosInstance";

const instance = axiosInstance();
instance.defaults.baseURL += "/editor";

export async function getEditorContent(proposal_id, search_type) {
  const response = await instance.get(
    `/get-content/${search_type}/${proposal_id}`
  );
  return response.data;
}

export async function updateEditorContent(proposal_id, content, search_type) {
  const response = await instance.post("/update-content", {
    proposal_id,
    content,
    search_type,
  });
  return response.data;
}

export async function getProposals() {
  const response = await instance.get(`/get-proposals`);
  return response.data;
}

export async function getProposal(search_type, proposal_id) {

  const response = await instance.get(
    `/get-proposal/${search_type}/${proposal_id}`
  );
  return response.data;
}

export async function deleteProposal({ proposal_id, search_type }) {
  const response = await instance.post("/delete-proposal", {
    proposal_id,
    search_type,
  });
  return response.data;
}

export async function initializeEditor(proposal_id, search_type, content) {
  const response = await instance.post("/initialize-editor", {
    proposal_id,
    search_type,
    content,
  });
  return response.data;
}
